// src/use-machine.ts
import { onBeforeUnmount, onMounted, shallowRef, watch, watchEffect } from "vue";
function useService(machine, options) {
  const { actions, state: hydratedState, context } = options ?? {};
  const _machine = typeof machine === "function" ? machine() : machine;
  const service = context ? _machine.withContext(context.value) : _machine;
  onMounted(() => {
    service.start(hydratedState);
    if (service.state.can("SETUP")) {
      service.send("SETUP");
    }
    onBeforeUnmount(() => {
      service.stop();
    });
  });
  watchEffect(() => {
    service.setOptions({ actions });
  });
  if (context) {
    watch(context, service.setContext, { deep: true });
  }
  return service;
}
function useMachine(machine, options) {
  const service = useService(machine, options);
  const state = shallowRef(service.state);
  onMounted(() => {
    const unsubscribe = service.subscribe((nextState) => {
      state.value = nextState;
    });
    onBeforeUnmount(() => {
      unsubscribe?.();
    });
  });
  return [state, service.send, service];
}

export {
  useService,
  useMachine
};
